import { type ComponentPropsWithoutRef, forwardRef } from "react";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import { useBelowBreakpoint } from "../../hooks";

import * as theme from "./TriggerHelpIcon.css";

// Fixed positioned help icon to be used for help menu. `forwardRef`, not a
// `ref` prop: legacy's React 18 drops `ref` props, and Radix anchors to it.
export const TriggerHelpIcon = forwardRef<
    HTMLButtonElement,
    ComponentPropsWithoutRef<"button">
>(({ className, ...props }, ref) => {
    const belowLg = useBelowBreakpoint("lg");
    return (
        <button
            ref={ref}
            className={cx(theme.root, belowLg && theme.rootBelowLg, className)}
            {...props}
        >
            <QuestionCircleOutlined className={theme.icon} />
        </button>
    );
});
